(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.confirm', {
            parent: 'public',
            url: '/confirm/:eventId',
            data: {
                authorities: [],
                specialClass: " gray-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.confirm': {
                    templateUrl: 'app/public/confirm/confirm.html',
                    controller: 'PublicConfirmController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@public.confirm': {}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
